import React from 'react'

const Error = () => {
    return (
        <div>
           <h1>Error Page</h1> 
        </div>
    )
}

export default Error
